<app-page [headline]="formTitle()">
  <div stack-layout justifyContent="center" gap="lg" [fullWidth]="true">
    <div
      stack-layout
      gap="sm"
      borderRadius="xs"
      elevation="raised"
      paddingVertical="sm"
      paddingHorizontal="md"
    >
      <Text role="headline-small"> Contact Info </Text>
      <div
        grid-layout
        gap="md"
        templateColumns="repeat(auto-fit, minmax(202px, 1fr))"
      >
        <div>
          <Text role="label">First Name</Text>
          <app-input
            [form]="userForm"
            controlName="firstName"
            [invalid]="
              userForm.controls['firstName'].invalid &&
              userForm.controls['firstName'].touched
            "
          ></app-input>
        </div>

        <div>
          <Text role="label">Last Name</Text>
          <app-input
            [form]="userForm"
            controlName="lastName"
            [invalid]="
              userForm.controls['lastName'].invalid &&
              userForm.controls['lastName'].touched
            "
          ></app-input>
        </div>

        <div>
          <Text role="label">Email</Text>

          <app-input
            [form]="userForm"
            controlName="email"
            [invalid]="
              userForm.controls['email'].invalid &&
              userForm.controls['email'].touched
            "
            type="email"
          ></app-input>
        </div>
      </div>
      <div row-layout gap="lg" alignItems="center">
        <Checkbox
          label="Admin"
          [checked]="userForm.value.isAdmin || false"
          (change)="toggleAdmin()"
        />
        <Checkbox
          label="LINC Admin"
          [checked]="userForm.value.isLincUser || false"
          (change)="toggleLincAdmin()"
        />
      </div>
    </div>

    <div
      box-layout
      borderRadius="xs"
      elevation="raised"
      paddingVertical="sm"
      paddingHorizontal="md"
    >
      <div box-layout paddingBottom="sm">
        <Text role="headline-small"> Entity Permissions </Text>
      </div>
      <div
        grid-layout
        gap="md"
        templateColumns="repeat(auto-fit, minmax(340px, 1fr))"
      >
        @if (refreshed) {
          @for (
            entity of entityService.allBusinessEntities.value();
            track entity
          ) {
            <div row-layout gap="sm" alignItems="center">
              <Checkbox
                label="{{ entity.name }}"
                [checked]="isAssociated(entity)"
                (change)="toggleEntity(entity)"
              />
              <app-region-tag [region]="entity.region" />
            </div>
          }
        }
      </div>
    </div>

    <div box-layout borderRadius="xs" elevation="raised">
      <div box-layout paddingHorizontal="md" paddingVertical="sm">
        <Text role="headline-small"> Functional Permissions </Text>
      </div>
      @if (refreshed) {
        @for (group of permissionService.permissionGroups(); track group) {
          <div box-layout paddingHorizontal="md" paddingVertical="sm">
            <Text role="title-small" color="on-background-variant">{{
              group
            }}</Text>
          </div>
          <div
            grid-layout
            gap="md"
            templateColumns="repeat(auto-fit, minmax(202px, 1fr))"
            paddingHorizontal="md"
            paddingVertical="sm"
          >
            @for (
              permission of permissionService.permissionsForGroup(group);
              track permission
            ) {
              <div row-layout gap="sm">
                <Checkbox
                  label="{{ permission.name }}"
                  [checked]="isAssigned(permission)"
                  (change)="togglePermission(permission)"
                />
                <div row-layout gap="sm" alignItems="center">
                  @for (region of permission.regions; track region) {
                    <app-region-tag [region]="region" />
                  }
                </div>
              </div>
            }
          </div>
          @if (!$last) {
            <Divider border="light" />
          }
        }
      }
    </div>

    <div row-layout justifyContent="end" paddingBottom="lg" gap="lg">
      <button text-button variant="warn" size="md" (click)="cancelSave()">
        Cancel
      </button>
      <button
        text-button
        size="md"
        (click)="saveUser()"
        [loading]="saving()"
        [disable]="userForm.invalid"
      >
        {{ editing() ? 'Update User' : 'Create User' }}
      </button>
    </div>
  </div>
</app-page>
